import * as localforage from "localforage";
import { phpRequest } from "./phpRequest";

export const createCompanyGroupAPI = async (name) => {
  const company_id = await localforage.getItem("userCompanyID");
  return phpRequest.post("/company/group/create", {
    company_id,
    name,
  });
};
